import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

const initialState = {
  isScreening: false,
  isLoaded: false,
};

export const ScreeningSlice = createSlice({
  name: "screeningStatus",
  initialState,
  reducers: {
    updateScreeningStatus: (state, action: PayloadAction<any>) => {
      state.isScreening = action.payload.screening;
      state.isLoaded = action.payload.loaded;
    },
  },
});

export const { updateScreeningStatus } = ScreeningSlice.actions;
export const ScreeningDetailsState = (state: RootState) =>
  state.screeningStatus;
export default ScreeningSlice.reducer;
